const BASE62_ALPHABET =
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const BASE62_BASE = 62n;

const stringToBytes = value => {
  const text = String(value);

  if (typeof TextEncoder === 'function') {
    return new TextEncoder().encode(text);
  }

  if (typeof Buffer !== 'undefined') {
    return Uint8Array.from(Buffer.from(text, 'utf8'));
  }

  throw new Error('No utf8 encoder available');
};

const bytesToString = bytes => {
  if (typeof TextDecoder === 'function') {
    return new TextDecoder().decode(bytes);
  }

  if (typeof Buffer !== 'undefined') {
    return Buffer.from(bytes).toString('utf8');
  }

  throw new Error('No utf8 decoder available');
};

/**
 * Encodes a string as base62 (URL-safe).
 * @param {string} value
 * @returns {string}
 */
export const encodeMultiApp = value => {
  const bytes = stringToBytes(value);

  if (!bytes.length) {
    return '';
  }

  let leadingZeros = 0;
  while (leadingZeros < bytes.length && bytes[leadingZeros] === 0) {
    leadingZeros += 1;
  }

  let number = 0n;
  for (let index = leadingZeros; index < bytes.length; index += 1) {
    number = number * 256n + BigInt(bytes[index]);
  }

  if (number === 0n) {
    return BASE62_ALPHABET[0].repeat(leadingZeros || 1);
  }

  let encoded = '';
  while (number > 0n) {
    encoded = BASE62_ALPHABET[Number(number % BASE62_BASE)] + encoded;
    number /= BASE62_BASE;
  }

  return BASE62_ALPHABET[0].repeat(leadingZeros) + encoded;
};

/**
 * Decodes a base62 string back to utf8 text.
 * @param {string} value
 * @returns {string}
 */
export const decodeMultiApp = value => {
  const encoded = String(value);

  if (!encoded) {
    return '';
  }

  let leadingZeros = 0;
  while (
    leadingZeros < encoded.length &&
    encoded[leadingZeros] === BASE62_ALPHABET[0]
  ) {
    leadingZeros += 1;
  }

  let number = 0n;
  for (let index = leadingZeros; index < encoded.length; index += 1) {
    const digit = BASE62_ALPHABET.indexOf(encoded[index]);
    if (digit < 0) {
      throw new Error('Invalid base62 character');
    }
    number = number * BASE62_BASE + BigInt(digit);
  }

  const bytes = [];
  while (number > 0n) {
    bytes.unshift(Number(number % 256n));
    number /= 256n;
  }

  if (!leadingZeros && !bytes.length) {
    return '';
  }

  const resultBytes = new Uint8Array(leadingZeros + bytes.length);
  for (let index = 0; index < bytes.length; index += 1) {
    resultBytes[leadingZeros + index] = bytes[index];
  }

  return bytesToString(resultBytes);
};
